document.addEventListener("DOMContentLoaded", function () {
  const params = new URLSearchParams(window.location.search);

  params.forEach((value, key) => {
    if (key.startsWith("filter.v.")) {
      const inputSelector = `input[name="${key}"][value="${value}"]`;
      const input = document.querySelector(inputSelector);

      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  });
});
